import { getWeek as f } from "./getWeek.js";
import { toDate as n } from "./toDate.js";
function m(e, o, r) {
  const t = n(e), a = f(t, r) - o;
  return t.setDate(t.getDate() - a * 7), t;
}
export {
  m as default,
  m as setWeek
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns@3.6.0/~/date-fns/setWeek.js
// module id = 1401
// module chunks = 41